export default function briefUpdateUploadAction(context, payload, done) {
    context.dispatch('BRIEF_UPDATE_UPLOAD', payload);
    return done();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-update-upload.jsx